import { lighten, transparentize } from 'polished/lib/index';

import { COLORS } from 'shared/constants/theme';

export default {
  button: {
    normal: {
      backgroundColor: 'transparent',
      borderColor: COLORS.cerulean,
      color: COLORS.cerulean,
      textDecoration: 'none'
    },
    hover: {
      backgroundColor: transparentize(0.8, COLORS.cerulean),
      borderColor: lighten(0.2, COLORS.cerulean),
      color: lighten(0.2, COLORS.cerulean),
      textDecoration: 'none'
    },
    disabled: {
      backgroundColor: lighten(0.2, COLORS.cerulean),
      borderColor: lighten(0.2, COLORS.cerulean),
      color: COLORS.white,
      textDecoration: 'none'
    }
  }
};
